import { get } from 'bukku/shared/ApiService';
import { all, call, fork, put, takeEvery } from 'bukku/shared/SagaService';
import { errorSagaFn, requestSagaPullingFn, successSagaFn } from '../helper';
import actions from './actions';
// import { AuditName } from './enums';
import { dummyAccountAudit, dummyAccountAudits, useDummyAccountAudit, useDummyAccountAudits } from './dummy';
import { getServerUrlPrefix } from './helper/getServerUrlPrefix';

const successKeys = [
    actions.AUDIT_MODULE_READ_SUCCESS,
    actions.AUDIT_MODULE_READ_ALL_SUCCESS,
];
const errorKeys = [
    actions.AUDIT_MODULE_READ_ERROR,
    actions.AUDIT_MODULE_READ_ALL_ERROR,
];
const getSuccessMsg = action => {
    switch (action.type) {
        default:
            return null;
    }
};

// Read contact audits list
function* readAllAuditsRequest() {
    yield takeEvery(actions.AUDIT_MODULE_READ_ALL_REQUEST, function* (action) {
        yield requestSagaPullingFn(action,
            function* ({ id, auditName, request }) {
                if (useDummyAccountAudits) {
                    yield put({
                        type: actions.AUDIT_MODULE_READ_ALL_SUCCESS,
                        audits: dummyAccountAudits.records,
                        pagination: dummyAccountAudits.paging,
                        auditName,
                    });
                }
                else {
                    const serverUrl = getServerUrlPrefix(auditName);

                    const response = yield call(get, `${serverUrl}/${id}/logs`, request);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.AUDIT_MODULE_READ_ALL_SUCCESS,
                        audits: data.records,
                        pagination: data.paging,
                        auditName,
                    });
                }
            });
    });
}

// Read contact audit (by id)
function* readAuditRequest() {
    yield takeEvery(actions.AUDIT_MODULE_READ_REQUEST, function* (action) {
        yield requestSagaPullingFn(action,
            function* ({ auditName, id, logId }) {
                if (useDummyAccountAudit) {
                    yield put({
                        type: actions.AUDIT_MODULE_READ_SUCCESS,
                        audit: dummyAccountAudit.record,
                        auditName,
                    });
                }
                else {
                    const serverUrl = getServerUrlPrefix(auditName);

                    const response = yield call(get, `${serverUrl}/${id}/logs/${logId}`);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.AUDIT_MODULE_READ_SUCCESS,
                        audit: data.record,
                        auditName,
                    });
                }
            });
    });
}
export default function* rootSaga() {
    yield all([
        fork(successSagaFn(successKeys, getSuccessMsg)),
        fork(errorSagaFn(errorKeys)),
        fork(readAllAuditsRequest),
        fork(readAuditRequest),
    ]);
}
